import { useCallback, useEffect } from "react";

import Button from "ds/components/Button";
import { ArrowLeft } from "components/icons/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageUserGuides } from "hooks/useAnalytics/pages/userGuides";

import useAssistantPanelLearnStore from "../../useStore";
import useAssistantPanelLearnActiveGuide from "../../useActiveGuide";

const AssistantPanelLearnNavigationBackButton = () => {
  const { navigationState, setNavigationState } = useAssistantPanelLearnStore();
  const { activeGuide, currentStep } = useAssistantPanelLearnActiveGuide();
  const trackEvent = useAnalytics({ page: AnalyticsPageUserGuides.UserGuides });

  const userGuideName = activeGuide?.metadata.title;
  const userGuideStep = currentStep?.title;

  const handleBack = useCallback(() => {
    if (navigationState.level === "chapters") {
      trackEvent("Back Button Clicked", {
        from: "chapters",
        to: "groups",
        userGuideName,
        userGuideStep,
      });
      setNavigationState({ level: "groups" });
    } else if (navigationState.level === "guide") {
      trackEvent("Back Button Clicked", {
        from: "guide",
        to: "chapters",
        userGuideName,
        userGuideStep,
      });
      setNavigationState({
        level: "chapters",
        groupId: navigationState.groupId,
      });
    }
  }, [navigationState, setNavigationState, trackEvent, userGuideName, userGuideStep]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Backspace" && navigationState.level !== "groups") {
        event.preventDefault();
        handleBack();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleBack, navigationState.level]);

  if (navigationState.level === "groups") {
    return null;
  }

  return (
    <Button
      variant="ghost"
      size="small"
      startIcon={ArrowLeft}
      onPress={handleBack}
      aria-label="Go back"
    >
      Back
    </Button>
  );
};

export default AssistantPanelLearnNavigationBackButton;
